import { useEffect } from "react";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { SuggestionModal } from "../components/SuggestionModal";
import { ProtonWidget } from "../components/ProtonWidget";
import { applyWindowGlobals, ensurePageCss, syncHeadMeta } from "../lib/bootConfig";
import { initProtonWidget } from "../lib/protonWidget";
import { RADIOS_ORIGIN } from "../lib/origins";

export function GuidePage() {
  useEffect(() => {
    const title = "Como escutar rádio online: guia passo a passo | Radios.PRO";
    const description =
      "Aprenda a encontrar rádios por nome, cidade ou segmento, iniciar a transmissão e resolver problemas de áudio no Radios.PRO.";
    const canonical = RADIOS_ORIGIN + "/como-escutar-radio-online";
    syncHeadMeta({
      title,
      description,
      canonical,
      robots: null,
      ogTitle: title,
      ogDescription: description,
      ogUrl: canonical,
      ogImage: RADIOS_ORIGIN + "/assets/img/og-image.jpg",
      ogSiteName: "Radios.PRO",
    });
    document.body.className = "rp-body rp-guide-body";
    ensurePageCss("/assets/css/guide.css");
    applyWindowGlobals();
    initProtonWidget();
  }, []);

  return (
    <>
      <Header />
      <SuggestionModal />
      <main className="rp-guide-page">
        <nav className="rp-guide-breadcrumb" aria-label="Navegação estrutural">
          <a href="/">Início</a>
          <span aria-hidden="true">/</span>
          <span aria-current="page">Como escutar rádio online</span>
        </nav>

        <article className="rp-guide-article">
          <header className="rp-guide-header">
            <p className="rp-guide-kicker">Guia de escuta</p>
            <h1>Como escutar rádio online ao vivo</h1>
            <p className="rp-guide-lead">
              Encontre uma emissora AM, FM ou web e ouça pelo navegador. No Radios.PRO, você pode pesquisar pelo nome,
              cidade ou segmento musical.
            </p>
          </header>

          <section aria-labelledby="rp-guide-start-title">
            <h2 id="rp-guide-start-title">Como começar</h2>
            <ol className="rp-guide-steps">
              <li>
                <strong>Pesquise pelo nome da emissora.</strong> Se ainda não conhece uma estação, use os filtros de
                localização e segmento para explorar opções.
              </li>
              <li>
                <strong>Abra a página da rádio.</strong> Confira a cidade ou região, o estilo informado pela emissora e
                os streams disponíveis.
              </li>
              <li>
                <strong>Selecione uma transmissão e dê play.</strong> Algumas rádios oferecem mais de um stream, com
                endereços alternativos para a mesma estação.
              </li>
            </ol>
          </section>

          <section aria-labelledby="rp-guide-search-title">
            <h2 id="rp-guide-search-title">Como encontrar uma rádio por cidade ou estilo</h2>
            <p>
              Se você procura uma emissora local, pesquise pelo município ou estado. Para descobrir uma programação
              específica, filtre pelo segmento musical ou temático. Os resultados levam às páginas das próprias rádios,
              onde ficam reunidas as informações disponíveis para cada estação.
            </p>
            <p>
              As páginas podem incluir localização, slogan, segmentos, contatos, programação e mais de um stream. A
              quantidade de informações varia conforme os dados enviados ou mantidos pela emissora.
            </p>
          </section>

          <section aria-labelledby="rp-guide-types-title">
            <h2 id="rp-guide-types-title">Rádios AM, FM e web</h2>
            <p>
              Emissoras AM e FM também podem transmitir pela internet. As rádios web funcionam por streaming. Em todos
              os casos, a escuta online depende de a estação disponibilizar um stream ativo.
            </p>
            <p>Você pode abrir o Radios.PRO no celular ou computador, pesquisar uma emissora e iniciar a escuta pelo navegador.</p>
          </section>

          <section aria-labelledby="rp-guide-troubleshooting-title">
            <h2 id="rp-guide-troubleshooting-title">O que fazer se a rádio não tocar</h2>
            <ul className="rp-guide-steps">
              <li>Confirme se o dispositivo está conectado à internet e se o áudio não está silenciado.</li>
              <li>Se houver outros streams na página da emissora, teste uma alternativa.</li>
              <li>
                Se o stream não iniciar ou o áudio continuar sem funcionar, relate o problema na página da rádio para a
                equipe revisar a transmissão.
              </li>
            </ul>
          </section>

          <aside className="rp-guide-cta">
            <h2>Encontre uma rádio para ouvir</h2>
            <p>Pesquise no catálogo e abra a página da emissora para começar a escutar.</p>
            <a className="rp-guide-cta-link" rel="noopener" href="/">
              Buscar rádios online
            </a>
          </aside>
        </article>
      </main>
      <Footer />
      <ProtonWidget />
    </>
  );
}
